
<!-- Loading Spinner -->

<div class="tab-container">
  <!-- Banner -->
  <div class="review-banner">
    <div>
      <h2 class="app">{{bannerActionTitle()}}</h2>
      <p>{{bannerActionDescription()}}</p>
    </div>
    <lib-button [cssType]="'btn-primary'" [icon]="'rightarrow'"  [text]="bannerActionButtonTitle()" [size]="'large'"  (click)="bannerActionButtonClicked()"></lib-button>
  </div>


  <!-- Submission Overview -->
  <div class="submission-overview-container">
    <h2 class="app">{{isPolicyPage ? 'Policy' : 'Submission'}} Overview</h2>
    <div class="submission-overview">
      <!-- Business Information -->
      <div class="info-card">
        <div>
          <h3 class="app">Business Information</h3>
          <p class="large bold">{{summary().businessInfo?.businessName}}</p>
          <ul class="info-list">
            <li>Primary Address: {{summary().businessInfo?.primaryAddress}}</li>
            <li>Contractor License #: {{summary().businessInfo?.licenseNumber}}</li>
            <li>Primary Contact: {{summary().businessInfo?.primaryContactName}}</li>
            <li>Phone: {{summary().businessInfo?.primaryContactPhone}}</li>
            <li>Email: {{summary().businessInfo?.primaryContactEmail}}</li>
          </ul>
        </div>
        @if (isPolicyPage) {
          <lib-button [cssType]="'btn-secondary'"  [text]="'Update'" [size]="'small'"  [disabled]="true"></lib-button>
        } @else if(summary().status !== 'Indication' && summary().status !== 'Draft') {
          <lib-button [cssType]="'btn-secondary'"  [text]="'Review'" [size]="'small'" (click)="reviewSubmission()"></lib-button>
        }@else {
          <lib-button [cssType]="'btn-secondary'"  [text]="'Edit'" [size]="'small'" (click)="quoteAction()"></lib-button>
        }
      </div>

      <!-- Submission Information -->
      <div class="info-card">
        <div>
          <div class="submission-header">
            <h3 class="app">{{isPolicyPage ? 'Policy' : 'Submission'}} Information</h3>
            <lib-button [cssType]="'btn-link'"  [text]="'View Pricing'" [icon]="'circleright'"  [buttonType]="'button'" (click)="GoToTab('pricing')"></lib-button>
          </div>
          <p class="large bold">{{isPolicyPage ? 'Policy' : 'Submission'}} {{isPolicyPage ? summary().policyNumber :summary().submissionNumber ?? 'N/A'}} | Status: {{summary().friendlyStatus}}</p>
          <ul class="info-list">
            <li>Program: {{summary().programName}}</li>
            <li>Policy Effective Date: {{summary().policyEffectiveDate | date:'MM/dd/yyyy'}}</li>
            <li>Created Date: {{summary().createDate | date:'MM/dd/yyyy'}}</li>
            <li>Agency: {{summary().agencyName}}</li>
            <li>Producer: {{summary().producerName}}</li>
          </ul>
        </div>
        @if (isPolicyPage) {
          <lib-button [cssType]="'btn-secondary'"  [text]="'Update'" [size]="'small'" [disabled]="true"></lib-button>
        } @else if(summary().status === 'Indication' || summary().status === 'Submission Declined'  || summary().status === 'Submitted') {
          <lib-button [cssType]="'btn-secondary'"  [text]="'Download'" [size]="'small'"  [disabled]="true"></lib-button>
     
        }@else{
          <div class="flex gap-[20px]">
          <lib-button [cssType]="'btn-secondary'"  [text]="'Download Quote'" [size]="'small'"  (click)="downloadQuote()"></lib-button>
          <lib-button [cssType]="'btn-secondary'"  [text]="'Download Broker Copy'" [size]="'small'"  (click)="downloadBrokerCopy()"></lib-button>
          </div>
        }
      </div>
    </div>
  </div>
  @if (isPolicyPage) {
    <div class="breakdown-container">
      <div class="breakdown-header">
        <h3 class="app">Issued Endorsements</h3>
        <lib-button [cssType]="'btn-link'"  [text]="isEndorsementsVisible ? 'Collapse' : 'Expand'" [icon]="isEndorsementsVisible ? 'circle-chevron-up' : 'circle-chevron-down'"  [buttonType]="'button'"  (click)="toggleEndorsements()"></lib-button>
      </div>
      <div *ngIf="isEndorsementsVisible" class="breakdown-content grid gap-5">
        <lib-ui-grid [(gridOptions)]="gridOptions" (actionEvent)="actionEvent($event)"></lib-ui-grid>
        @if (numberOfMoreEndorsements() > 0) {
          <p class="pl-3">+{{numberOfMoreEndorsements()}} More Endorsement{{numberOfMoreEndorsements() === 1 ? '' : 's'}}</p>
        }
        <lib-button [cssType]="'btn-secondary'"  [text]="'View Endorsements'" [size]="'small'" (click)="GoToTab('endorsements')"></lib-button>
      </div>
    </div>
  }
</div>

